import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CarrierCodeService {

  constructor() { }

  carrierCode(){
   let carrierCode :any= [
    { carrierCode: 'IX', flightName: 'AirIndia Express',logo:'../../../assets/images/I5.svg' },
    { carrierCode: 'SQ', flightName: 'Singapore Airlines' ,logo:'../../../assets/images/SQ.svg'},
    { carrierCode: 'UK', flightName: 'Vistara',logo:'../../../assets/images/UK.svg' },
    { carrierCode: '6E', flightName: 'IndiGo',logo:'../../../assets/images/6E.svg' },
    { carrierCode: 'I5', flightName: 'AirIndia Express' ,logo:'../../../assets/images/I5.svg'},
    { carrierCode: 'AI', flightName: 'Air India',logo:'../../../assets/images/AI.svg' },
    { carrierCode: 'QP', flightName: 'Akasa Air',logo:'../../../assets/images/QP.svg' },
    { carrierCode: 'SG', flightName: 'SpiceJet',logo:'../../../assets/images/SG.svg' },
    { carrierCode: 'H1', flightName: 'Hahn Air',logo:'../../../assets/images/H1.png' },
    { carrierCode: 'X1', flightName: 'Hahn Air',logo:'../../../assets/images/H1.png' },
    { carrierCode: 'EK', flightName: 'Emirates',logo:'../../../assets/images/EK.svg' },
    { carrierCode: 'VS', flightName: 'Virgin Atlantic',logo:'../../../assets/images/VS.svg' },
    { carrierCode: 'CX', flightName: 'Cathay Pacific',logo:'../../../assets/images/CX.svg' },
    { carrierCode: 'LX', flightName: 'Swiss International Air Lines' ,logo:'../../../assets/images/LX.svg'},
    { carrierCode: 'EY', flightName: 'Etihad Airways' ,logo:'../../../assets/images/EY.svg'},
    { carrierCode: 'UA', flightName: 'United' ,logo:'../../../assets/images/UA.svg'},
    { carrierCode: 'TK', flightName: 'Turkish Airlines',logo:'../../../assets/images/TK.svg' },
    { carrierCode: 'SV', flightName: 'Saudia',logo:'../../../assets/images/SV.svg' },
    { carrierCode: 'SK', flightName: 'SAS',logo:'../../../assets/images/SK.svg' },
    { carrierCode: 'QR', flightName: 'Qatar Airways',logo:'../../../assets/images/QR.svg' },
    { carrierCode: 'AY', flightName: 'Finnair',logo:'../../../assets/images/AY.svg' },
    { carrierCode: 'MS', flightName: 'Egypt Air',logo:'../../../assets/images/MS.svg' },
    { carrierCode: 'ET', flightName: 'Ethiopian Air',logo:'../../../assets/images/ET.svg' },
    { carrierCode: 'WY', flightName: 'Oman Av (SAOG)',logo:'../../../assets/images/WY.svg' },
    { carrierCode: 'BA', flightName: 'British Airways',logo:'../../../assets/images/BA.svg' },
    { carrierCode: 'GF', flightName: 'Gulf Air',logo:'../../../assets/images/GF.svg' },
    { carrierCode: 'LH', flightName: 'Lufthansa',logo:'../../../assets/images/LH.svg' },
    { carrierCode: 'KC', flightName: 'Air Astana',logo:'../../../assets/images/KC.svg' },
    { carrierCode: 'EN', flightName: 'Air Dolomiti',logo:'../../../assets/images/EN.svg' },
    { carrierCode: 'KL', flightName: 'KLM Royal Dutch Airlines' ,logo:'../../../assets/images/KL.svg'},
    { carrierCode: 'AF', flightName: 'Air France',logo:'../../../assets/images/AF.svg' },
    { carrierCode: 'AZ', flightName: 'ITA Airways',logo:'../../../assets/images/AZ.svg' },
    { carrierCode: 'KU', flightName: 'Kuwait Airways',logo:'../../../assets/images/KU.svg' },
    { carrierCode: 'TG', flightName: 'Thai Airways',logo:'../../../assets/images/TG.svg' },
    { carrierCode: 'DL', flightName: 'Delta',logo:'../../../assets/images/DL.svg' },
    { carrierCode: 'NH', flightName: 'All Nippon',logo:'../../../assets/images/NH.svg' },
    { carrierCode: 'AC', flightName: 'Air Canada',logo:'../../../assets/images/AC.svg' },
    { carrierCode: 'LO', flightName: 'LOT Polish Air',logo:'../../../assets/images/LO.svg' },
    { carrierCode: 'UL', flightName: 'SriLankan Airlines',logo:'../../../assets/images/UL.svg' },

    { carrierCode: 'G9', flightName: 'Air Arabia',logo:'../../../assets/images/G9.svg' },
    { carrierCode: 'XY', flightName: 'Flynas',logo:'../../../assets/images/XY.svg' },
    { carrierCode: 'FZ', flightName: 'flydubai',logo:'../../../assets/images/FZ.svg' },
    { carrierCode: 'HY', flightName: 'Uzbekistan',logo:'../../../assets/images/HY.svg' },
    { carrierCode: 'BG', flightName: 'Biman Bangladesh',logo:'../../../assets/images/BG.svg' },
    { carrierCode: '9I', flightName: 'Alliance Air',logo:'../../../assets/images/9I.svg' },
    { carrierCode: 'S5', flightName: 'Star Air',logo:'../../../assets/images/STAir.png' },
    { carrierCode: 'QF', flightName: 'Qantas',logo:'../../../assets/images/QF.svg' },
    { carrierCode: 'VJ', flightName: 'Vietjet Air',logo:'../../../assets/images/VJ.svg' },
    { carrierCode: 'VN', flightName: 'Vietnam Airlines',logo:'../../../assets/images/VN.svg' },
    { carrierCode: 'MH', flightName: 'Malaysia Airlines',logo:'../../../assets/images/MH.svg' },
    { carrierCode: 'OD', flightName: 'Malindo Air',logo:'../../../assets/images/OD.svg' },
    { carrierCode: 'AS', flightName: 'Alaska Airlines',logo:'../../../assets/images/AS.svg' },
    { carrierCode: 'MK', flightName: 'Air Mauritius',logo:'../../../assets/images/MK.svg' },
    { carrierCode: 'OZ', flightName: 'Asiana Airlines',logo:'../../../assets/images/OZ.svg' },
    { carrierCode: 'KP', flightName: 'Asky Airlines',logo:'../../../assets/images/KP.svg' },
    { carrierCode: 'PG', flightName: 'Bangkok Airways',logo:'../../../assets/images/PG.svg' },
    { carrierCode: 'VZ', flightName: 'Thai VietJet',logo:'../../../assets/images/VZ.svg' },
    { carrierCode: 'VA', flightName: 'Virgin Australia',logo:'../../../assets/images/VA.svg' },
    
    
      { carrierCode: 'AA', flightName: 'American Airlines',logo:'../../../assets/images/' },
      { carrierCode: 'G8', flightName: 'GoAir' ,logo:'../../../assets/images/'},
      { carrierCode: 'SA', flightName: 'South African Airways',logo:'../../../assets/images/' },
      { carrierCode: 'QF', flightName: 'Qantas',logo:'../../../assets/images/' },
      { carrierCode: 'CA', flightName: 'Air China' ,logo:'../../../assets/images/'},
      { carrierCode: 'AM', flightName: 'Aeroméxico',logo:'../../../assets/images/' },
      { carrierCode: 'SU', flightName: 'Aeroflot' ,logo:'../../../assets/images/'},
  

    ];
    return carrierCode
  }
}
